import React from 'react';
import Sun from '../images/solarsystem/sun.webp';
import Mercury from '../images/solarsystem/mercury.webp';
import Venus from '../images/solarsystem/venus.webp';
import Earth from '../images/solarsystem/earth.webp';
import Mars from '../images/solarsystem/mars.webp';
import Jupiter from '../images/solarsystem/jupiter.webp';
import Saturn from '../images/solarsystem/saturn.webp';
import Uranus from '../images/solarsystem/uranus.webp';
import Neptune from '../images/solarsystem/neptune.webp';

const LoadingScreen = () => (
  <div className="flex flex-col items-center justify-center w-screen h-screen bg-black text-white font-orbitron overflow-hidden">

    {/* Solar System Container */}
    <div className="relative flex items-center justify-center w-[48rem] h-[48rem]">

      {/* Sun */}
      <img
        src={Sun}
        alt="Sun"
        className="absolute w-16 h-16 drop-shadow-[0_0_40px_rgba(255,215,0,0.6)]"
      />

      {/* Mercury */}
      <div className="absolute w-20 h-20 border border-dashed border-white/10 rounded-full animate-orbit-3s">
        <img src={Mercury} alt="Mercury" className="absolute left-1/2 top-0 w-2 h-2 -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Venus */}
      <div className="absolute w-28 h-28 border border-dashed border-white/10 rounded-full animate-orbit-4s">
        <img src={Venus} alt="Venus" className="absolute left-1/2 top-0 w-[14px] h-[14px] -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Earth */}
      <div className="absolute w-36 h-36 border border-dashed border-white/10 rounded-full animate-orbit-5s">
        <img src={Earth} alt="Earth" className="absolute left-1/2 top-0 w-4 h-4 -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Mars */}
      <div className="absolute w-44 h-44 border border-dashed border-white/10 rounded-full animate-orbit-6s">
        <img src={Mars} alt="Mars" className="absolute left-1/2 top-0 w-2.5 h-2.5 -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Jupiter */}
      <div className="absolute w-56 h-56 border border-dashed border-white/10 rounded-full animate-orbit-8s">
        <img src={Jupiter} alt="Jupiter" className="absolute left-1/2 top-0 w-10 h-10 -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Saturn */}
     <div className="absolute w-72 h-72 border border-dashed border-white/10 rounded-full animate-orbit-10s">
     <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
        {/* Circular ring */}
        {/* <div className="absolute w-14 h-14 border-2 border-amber-200 rounded-full opacity-70"></div> */}
        {/* Saturn */}
        <img src={Saturn} alt="Saturn" className="w-8 h-8 relative z-10" />
      </div>
    </div>

      {/* Uranus */}
      <div className="absolute w-80 h-80 border border-dashed border-white/10 rounded-full animate-orbit-12s">
        <img src={Uranus} alt="Uranus" className="absolute left-1/2 top-0 w-5 h-5 -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Neptune */}
      <div className="absolute w-96 h-96 border border-dashed border-white/10 rounded-full animate-orbit-14s">
        <img src={Neptune} alt="Neptune" className="absolute left-1/2 top-0 w-[18px] h-[18px] -translate-x-1/2 -translate-y-1/2" />
      </div>
    </div>

    {/* Loading Text */}
    <div className="absolute bottom-[12%] text-lg animate-pulse text-white/80">
      Aligning the stars...
    </div>
  </div>
);

export default LoadingScreen;
